import React, { useEffect, useRef } from "react";

import * as d3 from "d3";

import { LayoutType } from "src/organization/pages/project/environment/metrics/logs/types";

import { tickValuesForScaleBand } from "../utils";

import Ruler from "./ruler";
import * as S from "./style";
import Yaxis from "./Yaxis";

const DEFAULT_LEFT_TICKS = 6;

export type SvgLayoutProps = {
  onMouseMove?: (event) => void;
  onMouseLeave?: (event) => void;
} & LayoutType;

const SvgLayout = (props: SvgLayoutProps) => {
  const {
    positions,
    children,
    xScale,
    yScale,
    chartId,
    tick,
    onMouseMove,
    onMouseLeave
  } = props;

  const svgRef = useRef<SVGSVGElement>(null);
  const xAxisRef = useRef<SVGGElement>(null);

  useEffect(() => {
    const xDomain = xScale.domain();

    const tickValuesFn = tickValuesForScaleBand(
      xDomain[0],
      xDomain[xDomain.length - 1]
    );

    const axisBottom = d3
      .axisBottom(xScale)
      .tickFormat(tick?.x?.format)
      .tickValues(xDomain.filter(tickValuesFn));

    const axisGroup = d3
      .select(xAxisRef.current)
      .attr("transform", positions.xTransform)
      //@ts-expect-error d3 7.8.5 incorect type
      .call(axisBottom);

    axisGroup.selectAll(".tick").each(function (d) {
      //Note: the use of function literal is intentional here
      // so that d3 can bind the data to this keyword
      d3.select(this)
        .select("text")
        .classed("new-day-start", new Date(d as number).getHours() === 0);
    });
  }, [
    positions.xRangeEnd,
    positions.xRangeStart,
    positions.xTransform,
    tick?.x?.count,
    tick?.x?.format,
    xScale
  ]);

  const maxPoint = yScale.domain()[1];

  return (
    <S.Svg
      ref={svgRef}
      id={`${chartId}-chart`}
      className="chart-graph"
      width={positions.width}
      height={positions.height}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
      // onMouseUp tempoprary solution to when deployment overlay
      // modal is triggered. See getCursorDataFunc to use classList that excludes chart-graph
      // for better implementation. This has a bug on mobile when clicking on an activity
      onMouseUp={onMouseLeave}
    >
      <Ruler
        id={chartId}
        position={positions}
        ticksCount={tick?.y?.count || DEFAULT_LEFT_TICKS}
        xScale={xScale}
        yScale={yScale}
        max={maxPoint}
      />
      <S.Axis ref={xAxisRef} isXAxis />

      {children}

      <Yaxis
        numProgression={tick?.y?.count || DEFAULT_LEFT_TICKS}
        xAxis={xScale}
        yAxis={yScale}
        maxPoint={maxPoint}
        transform={positions.yTransform}
        format={tick?.y?.format}
      />
    </S.Svg>
  );
};

export default SvgLayout;
